import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';

export function UserAvatar ({ src, user, size = 60 }) {
  const srcExists = !!src;
  const displaySrc = srcExists
    ? src
    : (user && user.avatar) ? user.avatar.url : null;
  return (
    <Avatar size={size} icon={<UserOutlined />} src={displaySrc} />
  );
}
